// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1Ys1B","fileBtn":"File_fileBtn__18KbO","closeBtn":"File_closeBtn__262Vm","fileSelected":"File_fileSelected__2LroN","disabled":"File_disabled__3T8hZ"};